import type { Action } from 'lib/core/flow';
import USER_ACTION_TYPES from 'modules/Dashboard/Auth/store/actions/user/types';

export type UserState = {
  user: ?Object
};

const initialState = (): UserState => ({
  user: null
});

/* ************                         **************
   ************ SET Reducers **************
   ************                         ************** */

const SET_USER = (state: UserState, action: Action) => ({
  ...state,
  user: action.payload
});

const RESET_INITIAL_STATE = () => ({
  ...initialState()
});

export default (state: UserState = initialState(), action: Action) => {
  switch (action.type) {
    // setters
    case USER_ACTION_TYPES.SET_USER:
      return SET_USER(state, action);

    case USER_ACTION_TYPES.RESET_USER_STATE:
      return RESET_INITIAL_STATE();
    default:
      return state;
  }
};
